import { GraphQLClient } from 'graphql-request';
import { RequestConfig } from 'node_modules/graphql-request/build/esm/types';

export const getGraphqlRequestClient = (url: string, config: RequestConfig = {}) => new GraphQLClient(url, config);
